import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m331-256 149-89 149 90-40-169 131-114-173-15-67-159-67 159-173 14 131 114-40 169Zm149 3L293-140q-12 7-23 6-12-1-21-8-10-6-14-17-4-10-2-24l50-213-165-144q-11-9-13-20-3-11 0-22t12-19q10-7 23-8l218-19 85-202q5-12 16-18t21-6q11 0 21 6 11 6 16 18l85 202 218 19q13 1 23 8 9 8 12 19t0 22q-2 11-13 20L677-396l50 213q2 14-2 24-4 11-14 17-9 7-21 8-11 1-23-6L480-253Zm0-221Z"/>',
  f: '<path d="M480-253 293-140q-12 7-23 6-12-1-21-8-10-6-14-17-4-10-2-24l50-213-165-144q-11-9-13-20-3-11 0-22t12-19q10-7 23-8l218-19 85-202q5-12 16-18t21-6q11 0 21 6 11 6 16 18l85 202 218 19q13 1 23 8 9 8 12 19t0 22q-2 11-13 20L677-396l50 213q2 14-2 24-4 11-14 17-9 7-21 8-11 1-23-6L480-253Z"/>',
};

export default data;
